import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
	const storage = JSON.parse(localStorage.getItem('persist:login'));
	const token = storage && storage?.token;
	const timeStamp = localStorage.getItem('loginTimeStamp');

	// TODO:check me

	if (token) {
		if (timeStamp !== '2') {
			localStorage.clear();
			window.location.reload();
			Cookies.remove('_uniqueDeviceId');
		}
	}

	//SERVER PART
	return storage ? children : <Navigate to="/auth/login" />;
}
